enum ActionTypes {
  EPHEMERAL_GET_REQUEST = 'EPHEMERAL_GET_REQUEST',
  EPHEMERAL_GET_REQUESTS = 'EPHEMERAL_GET_REQUESTS'
}

export default ActionTypes;
